import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  tableRoot: {
    minWidth: '1200px',
    overflowX: 'auto',
    tableLayout: 'auto',
    '& .MuiTableCell-root': {
      color: '#6B7177',
      borderBottom: '1px solid #ebeaea',
      padding: '2px 13px',
      fontSize: '12px',
      '& div:first-child': {
        '@media screen and (max-width: 960px)': {
          fontWeight: 'bold'
        }
      }
    },
    '& .MuiTableCell-head': {
      padding: '0 13px',
      fontWeight: 'bold',
      '& .MuiButton-text': {
        color: '#6B7177',
        fontWeight: 'bold',
        padding: '5px'
      }
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none'
    },
    '& p': {
      fontSize: '12px'
    },
    '& h6': {
      fontSize: '13px'
    },
    '& .MuiCollapse-root .MuiTableHead-root, & .MuiCollapse-root .MuiTableBody-root .MuiTableRow-root': {
      borderBottom: '1px solid #e1e1e1'
    }
  },
  bgBlue: {
    backgroundColor: '#E7F0FF'
  },
  quoteImage: {
    filter: 'drop-shadow(0px 1px 4px rgba(33, 33, 52, 0.1))',
    borderRadius: '4px',
    maxHeight: '60px',
    width: '100%',
    minWidth: '60px',
    objectFit: 'contain',
    padding: '5px'
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
}));
